import { useContext, useState } from "react";
import { Nav } from "react-bootstrap";
import { LuHouse, LuKey, LuUserRound, LuMessageCircle, LuLogOut, LuMenu, LuFileText } from "react-icons/lu";
import { AppContext } from "../../Context";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function NavItem({ to, children, onClick }) {
  return (
    <Nav.Link as={Link} to={to} className="nav-link" onClick={onClick}>
      {children}
    </Nav.Link>
  );
}

function LoginNavbar() {
  const { isAuth, logOut, currentUser } = useContext(AppContext);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    await logOut();
    toggleSidebar(); // Asegúrate de cerrar el sidebar al salir
    navigate("/");
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={`sidebar open`}>
        <div className="logo mb-3">
          <img src="/img/default-profile.jpg" alt="logo" />                                


        </div>
        <Nav className="flex-column">
        <NavItem to="/dashboard" onClick={toggleSidebar}>
          <LuHouse/>  Dashboard 
          </NavItem>
          <NavItem to="/dashboard/profile" onClick={toggleSidebar}>
            <LuUserRound />
            Perfil
          </NavItem>
          {currentUser && currentUser.isMaster && (
            <NavItem to="/master" onClick={toggleSidebar}>
              <LuKey />
              Master
            </NavItem>
          )}
          {currentUser?.isSuperAdmin === true && (
            <NavItem to="/registro-log" onClick={toggleSidebar}>
              <LuFileText />
              Registro log
            </NavItem>
          )}
          {/* Redirigir al Chat y cerrar el sidebar */}
          <NavItem
            to="/chat"
            onClick={() => {
              toggleSidebar();
              navigate("/chat");
            }}
          >
            <LuMessageCircle />
            Chat
          </NavItem>

          {isAuth && (
            <NavItem to="/signout" onClick={handleLogout}>
              <LuLogOut />
              Cerrar sesión
            </NavItem>
          )}
        </Nav>
        <div className="sidebar-brand p-2">
          {/* <h2>Tecnica</h2> */}
          {currentUser && (
            <div className="profile-info">
              <img
                src={currentUser.profilePicture || "/img/default-profile.jpg"}
                alt="Profile"
                className="profile-img"
              />
              <div className="text-start ps-2">
                <p className="m-0 fs-xs">{currentUser.displayName || "Usuario"}</p>
                <p className="m-0 fs-xs fw-bold">V2.2.2</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="sidebar-toggle" onClick={toggleSidebar}>
        <LuMenu />
      </div>
    </>
  );
}

export { LoginNavbar };

